import pre from './pre';
import post from './post';
import cart from './cart.vue';
import config from './config/index.vue';
import addon from './addon/index.vue';
import success from './success.vue';

export default {
  pre,
  components: {
    addon,
    config,
    cart,
    success,
  },
  post,
};
